var _path, _circle, _circle2, _circle3, _circle4, _circle5, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgr2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.699 98.2994H127.542C131.661 98.2994 134.999 94.9608 134.999 90.8423V86.0434C134.999 84.5155 134.54 83.0161 133.488 81.908C131.133 79.4278 126.116 75.2491 119.066 75.2854C112.028 75.3216 107.07 79.4568 104.742 81.9146C103.697 83.0185 103.242 84.5108 103.242 86.0311V90.8423C103.242 94.9608 106.581 98.2994 110.699 98.2994Z",
    fill: "#8FBC84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.121,
    cy: 64.8069,
    r: 12.6643,
    fill: "#8FBC84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.948,
    cy: 63.136,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.948,
    cy: 63.136,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.906,
    cy: 63.136,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.906,
    cy: 63.136,
    r: 3.27857,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.4238,
    y: 83.4707,
    width: 3.81189,
    height: 11.4357,
    transform: "rotate(39.1315 34.4238 83.4707)",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2922 54.1366L60.4283 54.0048L61.344 59.0603L38.1872 86.1983L33.4321 82.3297L55.2922 54.1366Z",
    fill: "#C2C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7331 98.0303C25.125 98.3021 24.4663 97.7665 24.6084 97.1157L25.7298 91.9786C25.8589 91.3874 26.566 91.14 27.0355 91.5217L30.7146 94.5134C31.1841 94.8951 31.086 95.6378 30.5336 95.8848L25.7331 98.0303Z",
    fill: "#89765A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8873 78.9788L36.8068 83.2252L42.3719 89.1362L40.5662 91.3557L33.5338 87.248L28.0815 81.1983L29.8873 78.9788Z",
    fill: "#89765A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0547,
    y: 84.7656,
    width: 3.81189,
    height: 11.4357,
    transform: "rotate(-42.2245 53.0547 84.7656)",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1884 59.726L27.8301 54.6285L32.9658 54.4829L56.3152 81.4555L51.7758 85.575L27.1884 59.726Z",
    fill: "#C2C0C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1434 95.5461C66.3207 96.1881 65.6922 96.7588 65.0702 96.5205L60.1599 94.6397C59.5949 94.4233 59.4565 93.687 59.9045 93.2803L63.4152 90.0926C63.8631 89.6858 64.5827 89.8943 64.7438 90.4776L66.1434 95.5461Z",
    fill: "#89765A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.932 88.5758L53.1701 82.3731L59.8504 77.7596L61.7733 79.8784L56.6554 86.2135L49.8549 90.6946L47.932 88.5758Z",
    fill: "#89765A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74.0723,
    y1: 78.7891,
    x2: 86.0732,
    y2: 66.7881,
    stroke: "#E08A8A",
    strokeWidth: 3.42496
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 74.2109,
    y1: 66.7891,
    x2: 85.6274,
    y2: 78.2056,
    stroke: "#E08A8A",
    strokeWidth: 3.42496
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgr2);
export default __webpack_public_path__ + "static/media/agr-2.6a7c49a155607e9a0be8d1368c192693.svg";
export { ForwardRef as ReactComponent };